import styled from 'styled-components';
import { AiColor16 } from 'ui/icons';
import { Link } from 'ui/links';
import { Tooltip } from 'ui/tooltip';
import { ListType } from 'modules/domains/list';
import { useIsModernizedSegmentationPageEnabled } from 'modules/segmentation/hooks';
import { List } from '../types';
import { EditListToolbar } from './EditListToolbar';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Description = styled.div`
  font-size: 12px;
`;

type NameCellProps = {
  list: List;
};

export const NameCell = ({ list }: NameCellProps) => {
  const { name, id, emailListType, hasBrandAffinityQuery, description } = list;
  const notDynamic = emailListType !== ListType.Dynamic;
  const usesBrandAffinity = emailListType === ListType.Dynamic && hasBrandAffinityQuery;
  const isModernizedSegmentationPageEnabled = useIsModernizedSegmentationPageEnabled();
  return (
    <>
      <Wrapper>
        {usesBrandAffinity && (
          <Tooltip tooltipContent="List uses Brand Affinity™" data-test="brandAffinityTooltipIcon">
            <AiColor16 />
          </Tooltip>
        )}
        <Link
          inTable
          data-test={`${name}-listName`}
          href={`/segmentation?emailListId=${id}`}
          useReactRouter={isModernizedSegmentationPageEnabled}
        >
          {name}
        </Link>
      </Wrapper>
      {description && description.length > 0 && (
        <Description data-test="list-description">{description}</Description>
      )}
      {notDynamic && <EditListToolbar emailListId={id} />}
    </>
  );
};
